import styled, { css } from "styled-components";
import { getThemeSpace } from "../helpers";
export const Cardcontainer = styled.figure `
	background-color: var(--surface-white);
	padding: 24px 15px;
	box-shadow: 0px 4px 4px rgba(0, 98, 170, 0.25);
	border-radius: 20px;
	display: flex;
	gap: 16px;
	flex-direction: column;
	align-items: center;
	text-align: center;
	width: 100%;
	max-width: 255px;
	min-height: 255px;

	div {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 120px;
		width: 100%;

		img {
			max-width: 120px;
			max-height: 120px;
			width: auto;
			height: auto;
		}
	}

	${(props) => {
    switch (props.variant) {
        case "large":
            return css `
					padding: 50px 24px;
					gap: 24px;

					div {
						height: auto;
					}
				`;
        case "cta":
            return css `
					gap: ${getThemeSpace("24")};

					min-width: 285px;
					min-height: 300px;

					div {
						max-height: 100px;

						img {
							max-width: 150px;
							max-height: 100px;
						}
					}

					button,
					a {
						margin-top: auto;

						width: 132px;
					}
				`;
        default:
            return css ``;
    }
}}

	svg {
		width: 100%;
	}
`;
//# sourceMappingURL=styles.js.map